import React from "react"
import { useSiteTranslations } from "@hooks/useSiteTranslations"

import * as s from "./ProductsList.module.scss"

import { ProductCardV3 } from "../product-card-v3/ProductCardV3.jsx"

export const ProductsList = ({ products, onItemClick }) => {
  const {
    shopTranslations: { shop },
  } = useSiteTranslations()

  return (
    <div className={s.ProductsList}>
      {!products || (products.length < 1 && <h4>{shop.noProducts}</h4>)}
      {products.map((product, idx) => (
        <ProductCardV3
          key={idx}
          product={product}
          className={s.ProductCard}
          onItemClick={onItemClick}
          hasAddToCardButton={false}
        />
      ))}
    </div>
  )
}
